import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule as AppCommonModule } from '@modules/common/common.module';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { ElementsModule } from '@modules/elements/elements.module';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { MatIconModule } from '@angular/material/icon';
import { KnotsModule } from '@modules/knots/knots.module';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { TagsModule } from '@modules/tags/tags.module';
import { UtilsModule } from '@modules/utils/utils.module';

@NgModule({
  imports: [
    AppCommonModule,
    BrowserAnimationsModule,
    CommonModule,
    ConnectionsModule,
    ElementsModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    PopoverDirective,
    ReactiveFormsModule,
    TagsModule,
    UtilsModule,
  ],
  exports: [],
  providers: [],
})
export class SearchModule {}
